export default __webpack_public_path__ + "static/media/after_live_chat.b0e95393.webp";